interface TextareaFieldProps {
  label?: string;
  value?: string;
}

const TextareaField = ({ label, value }: TextareaFieldProps) => {
  if (!value) return null;

  return (
    <div className="w-full py-3 space-y-2">
      {label && (
        <div className="text-primary-700 dark:text-primary-300 font-sans text-xs font-semibold uppercase tracking-widest">
          {label}
        </div>
      )}
      <blockquote className="border-l-2 border-primary-300 dark:border-primary-600 pl-4">
        <p className="font-serif italic text-primary-800 dark:text-primary-200 text-base leading-relaxed">
          {value}
        </p>
      </blockquote>
    </div>
  );
};

export default TextareaField;
